// extracted by mini-css-extract-plugin
export default {"container":"StatusIcon_container__VQGLn","container-incorrect":"StatusIcon_container-incorrect__QUskN","img":"StatusIcon_img__GfgNY"};